import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { I18nProvider } from "react-aria-components";
import { RouterProvider } from "react-router-dom";

import { ErrorBoundary } from "./components/ui/ErrorBoundary";
import { ToastProvider } from "./components/ui/Toast";
import { AuthProvider } from "./lib/auth";
import { useLocale } from "./lib/useLocale";
import { router } from "./router";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 },
  },
});

const LOCALE_TAG: Record<string, string> = {
  en: "en-US",
  tr: "tr-TR",
};

export function App() {
  const [locale] = useLocale();
  const tag = LOCALE_TAG[locale] ?? "en-US";
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <I18nProvider locale={tag}>
          <ToastProvider>
            <AuthProvider>
              <RouterProvider router={router} />
            </AuthProvider>
          </ToastProvider>
        </I18nProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
